import { t as r } from "./to-integer-or-infinity.js";
import { t } from "./to-length.js";
var o = RangeError,
  n = function n(_n) {
    if (void 0 === _n) return 0;
    var i = r(_n),
      e = t(i);
    if (i !== e) throw o("Wrong length or index");
    return e;
  };
export { n as t };